import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { to: '/dashboard', label: 'Trang chủ', emoji: '🏠' },
  { to: '/full-mock-test', label: 'Thi thử', emoji: '📄' },
  { to: '/library', label: 'Thư viện', emoji: '📚' },
  { to: '/report', label: 'Báo cáo', emoji: '📊' },
  { to: '/settings', label: 'Cài đặt', emoji: '⚙️' },
];

const TopNavBar = () => {
  const location = useLocation();
  const userName = localStorage.getItem('userFullName') || 'Bạn';
  const userAvatar = localStorage.getItem('userAvatar') || '🦊';

  return (
    <header className="sticky top-0 z-50 flex justify-between items-center px-8 py-3 w-full max-w-6xl mx-auto mt-4 bg-white/70 backdrop-blur-xl rounded-full shadow-[0px_8px_24px_rgba(94,46,26,0.06)]">
      <div className="flex items-center gap-2">
        <span className="material-symbols-outlined text-hupath-scout text-3xl" style={{ fontVariationSettings: "'FILL' 1" }}>park</span>
        <span className="text-2xl font-black text-hupath-scout tracking-tight font-headline">HuPath</span>
      </div>
      <nav className="hidden md:flex items-center gap-8">
        {NAV_ITEMS.map((item) => {
          const isActive = location.pathname === item.to || location.pathname.startsWith(item.to + '/');
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`font-headline transition-colors ${isActive ? 'text-hupath-scout border-b-2 border-hupath-scout font-bold pb-1' : 'text-hp-on-surface opacity-80 hover:text-hupath-scout'}`}
            >
              {item.emoji} {item.label}
            </Link>
          );
        })}
      </nav>
      <div className="flex items-center gap-3 bg-white p-1 pr-4 rounded-full shadow-sm">
        <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center text-lg">{userAvatar}</div>
        <span className="font-headline font-bold text-hp-on-surface">{userName}</span>
      </div>
    </header>
  );
};

export default TopNavBar;
